import { ModalProps } from '@tryhackme/thm-ui-components/dist/components/compounds/modal/modal.types';

import { AzureLab, AzureLabAction } from 'src/common/interfaces';

export enum TabOptions {
  ENVIRONMENT = 'Environment',
  CREDENTIALS = 'Credentials',
  ACTIONS = 'Actions',
}

export interface AzureCloudDetailsModalProps extends ModalProps {
  companyRefreshing: boolean;
  taskId: string;
  roomId: string;
  lab?: AzureLab;
}

export interface LabActionsProps {
  actions: AzureLabAction[];
  roomId: string;
  taskId: string;
  labId: string;
  disableActions: boolean;
}

export interface LabActionButtonProps {
  isDisabled: boolean;
  isPerformingAction: boolean;
  action: AzureLabAction;
  handleActionClick: (action: AzureLabAction) => Promise<void>;
}

export interface ExpiryCountdown {
  formattedExpiry: string | null;
  timeToExpire: number;
}

export interface AzureSectionProps {
  lab?: AzureLab;
  formattedExpiry: string | null;
}
